export default {
  get_all: { method: "get", url: "api/consultor/listar-perfis" },
  show: { method: "get", url: "api/consultor/visualizar-perfil{/id}" },
  store: { method: "post", url: "api/consultor/criar-perfil" },
  update: { method: "put", url: "api/consultor/atualizar-perfi{/id}" },
  delete: { method: "delete", url: "api/consultor/deletar-perfil{/id}" },

  get_categorias: { method: "get", url: "api/teste-gratis/get-categorias-organizacoes" },
};
